import { Box, Flex, Typography } from '@tempmee/react';
import defaultProfileImage from '~/images/defaultProfileImage.png';
import { OutlineXIcon, SolidHeartIcon } from '@tempmee/react-icons';
import { colors } from '@tempmee/tailwind';
import { Colors } from '~/themes/colors';

type TProfessionalType = 'favorite' | 'recent' | 'new';

interface IInvitedProfessionalPillProps {
  name: string;
  type: TProfessionalType;
  photoUrl?: string;
  onRemove: () => void;
}

const AVATAR_SIZE = 24;

export const InvitedProfessionalPill = ({
  name,
  type,
  photoUrl,
  onRemove,
}: IInvitedProfessionalPillProps) => {
  const isFavorite = type === 'favorite';
  const borderColor = isFavorite ? colors.favorites[400] : colors.secondary[500];
  const backgroundColor = isFavorite ? Colors.favorites_50 : Colors.primary_50;

  return (
    <Flex
      direction="row"
      align="center"
      gap={1}
      data-testid="invited-professional-pill"
      data-cy="invited-professional-pill"
      style={{
        border: `1.5px solid ${borderColor}`,
        backgroundColor,
        borderRadius: 24,
        display: 'inline-flex',
        overflow: 'hidden',
        position: 'relative',
        height: 38,
        paddingRight: 14,
        paddingLeft: isFavorite ? 20 : 10,
      }}
    >
      {isFavorite && (
        <Box data-testid="invited-pill-favorite-badge" style={{ position: 'absolute', left: 10 }}>
          <SolidHeartIcon color={colors.favorites[400]} width={16} />
        </Box>
      )}

      <Box
        as="span"
        role="img"
        aria-label="profile"
        style={{
          display: 'block',
          width: AVATAR_SIZE,
          height: AVATAR_SIZE,
          borderRadius: '50%',
          flexShrink: 0,
          border: isFavorite ? `1.5px solid ${colors.favorites[400]}` : 'none',
          backgroundImage: `url(${photoUrl || defaultProfileImage})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          backgroundColor: Colors.neutral_100,
        }}
      />

      <Typography
        size="body_small"
        color={colors.neutral[600]}
        numberOfLines={1}
        style={{ minWidth: 0 }}
      >
        {name}
      </Typography>

      <Box
        onClick={onRemove}
        data-testid="remove-professional"
        data-cy="remove-professional"
        style={{
          cursor: 'pointer',
          flexShrink: 0,
          display: 'flex',
          alignItems: 'center',
          marginLeft: 4,
        }}
      >
        <OutlineXIcon color={colors.secondary[500]} width={16} height={16} />
      </Box>
    </Flex>
  );
};
